import React, { useState } from 'react';
import { ThemeProvider } from './components/ThemeContext';
import { BottomNav } from './components/BottomNav';
import { ManagementScreen } from './components/ManagementScreen';
import { SubscriptionScreen } from './components/SubscriptionScreen';
import { OnboardingScreen } from './components/OnboardingScreen';
import { motion, AnimatePresence } from 'framer-motion';
type Tab = 'management' | 'subscription';
export function App() {
  const [activeTab, setActiveTab] = useState<Tab>('management');
  const [showOnboarding, setShowOnboarding] = useState(true);
  const handleOnboardingComplete = () => {
    setShowOnboarding(false);
  };
  return <ThemeProvider data-id="element-0">
      <div className="min-h-screen bg-neutral-950 flex justify-center" data-id="element-1">
        <div className="w-full max-w-[500px] min-h-screen bg-svt-bg text-svt-text font-sans selection:bg-svt-pink selection:text-white transition-colors duration-300 relative shadow-2xl" data-id="element-2">
          {showOnboarding ? <OnboardingScreen onComplete={handleOnboardingComplete} data-id="element-3" /> : <>
              <div className="pb-20" data-id="element-4">
                <AnimatePresence mode="wait" data-id="element-5">
                  {activeTab === 'management' && <motion.div key="management" initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: 20
              }} transition={{
                duration: 0.2
              }} data-id="element-6">
                      <ManagementScreen data-id="element-7" />
                    </motion.div>}
                  {activeTab === 'subscription' && <motion.div key="subscription" initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: 20
              }} transition={{
                duration: 0.2
              }} data-id="element-8">
                      <SubscriptionScreen data-id="element-9" />
                    </motion.div>}
                </AnimatePresence>
              </div>
              <BottomNav activeTab={activeTab} onTabChange={setActiveTab} data-id="element-10" />
            </>}
        </div>
      </div>
    </ThemeProvider>;
}